<op-enterprise-page
  [feature_video]="video"
  [feature_title]="text.title"
  [feature_description]="text.description"
  [hide_breadcrumb]="true"
></op-enterprise-page>
